'use strict';

var setImmediate = require('async/setImmediate');

var SmartBuffer = require('smart-buffer').SmartBuffer;

var gitUtil = require('./util');

exports = module.exports;

exports.serialize = function (dagNode, callback) {
  var lines = [];
  lines.push('tree ' + gitUtil.cidToSha(dagNode.tree['/']).toString('hex'));
  dagNode.parents.forEach(function (parent) {
    lines.push('parent ' + gitUtil.cidToSha(parent['/']).toString('hex'));
  });
  lines.push('author ' + gitUtil.serializePersonLine(dagNode.author));
  lines.push('committer ' + gitUtil.serializePersonLine(dagNode.committer));

  if (dagNode.encoding) {
    lines.push('encoding ' + dagNode.encoding);
  }

  if (dagNode.mergetag) {
    dagNode.mergetag.forEach(function (tag) {
      lines.push('mergetag object ' + gitUtil.cidToSha(tag.object['/']).toString('hex'));
      lines.push(tag.text);
    });
  }

  if (dagNode.signature) {
    lines.push('gpgsig -----BEGIN PGP SIGNATURE-----');
    lines.push(dagNode.signature.text);
  }

  lines.push('');
  lines.push(dagNode.message);
  var data = lines.join('\n');
  var outBuf = new SmartBuffer();
  outBuf.writeString('commit ');
  outBuf.writeString(data.length.toString());
  outBuf.writeUInt8(0);
  outBuf.writeString(data);
  setImmediate(function () {
    return callback(null, outBuf.toBuffer());
  });
};

exports.deserialize = function (data, callback) {
  var lines = data.toString().split('\n');
  var res = {
    gitType: 'commit',
    parents: []
  };

  var _loop = function _loop(_line) {
    var m = lines[_line].match(/^([^ ]+) (.+)$/);

    if (!m) {
      if (lines[_line] !== '') {
        setImmediate(function () {
          return callback(new Error('Invalid commit line ' + _line));
        });
      }

      res.message = lines.slice(_line + 1).join('\n');
      line = _line;
      return "break";
    }

    var key = m[1];
    var value = m[2];

    switch (key) {
      case 'tree':
        res.tree = {
          '/': gitUtil.shaToCid(Buffer.from(value, 'hex'))
        };
        break;

      case 'committer':
        res.committer = gitUtil.parsePersonLine(value);
        break;

      case 'author':
        res.author = gitUtil.parsePersonLine(value);
        break;

      case 'parent':
        res.parents.push({
          '/': gitUtil.shaToCid(Buffer.from(value, 'hex'))
        });
        break;

      case 'gpgsig':
        {
          if (value !== '-----BEGIN PGP SIGNATURE-----') {
            setImmediate(function () {
              return callback(new Error('Invalid commit line ' + _line));
            });
          }

          res.signature = {};
          var startLine = _line;

          for (; _line < lines.length - 1; _line++) {
            if (lines[_line + 1][0] !== ' ') {
              res.signature.text = lines.slice(startLine + 1, _line + 1).join('\n');
              break;
            }
          }

          line = _line;
          return "break";
        }

      case 'mergetag':
        {
          var mt = value.match(/^object ([0-9a-f]{40})$/);

          if (!mt) {
            setImmediate(function () {
              return callback(new Error('Invalid commit line ' + _line));
            });
          }

          var tag = {
            object: {
              '/': gitUtil.shaToCid(Buffer.from(mt[1], 'hex'))
            }
          };
          var _startLine = _line;

          for (; _line < lines.length - 1; _line++) {
            if (lines[_line + 1][0] !== ' ') {
              tag.text = lines.slice(_startLine + 1, _line + 1).join('\n');
              break;
            }
          }

          if (!res.mergetag) {
            res.mergetag = [];
          }

          res.mergetag.push(tag);
        }
        break;

      default:
        res[key] = value;
    }

    line = _line;
  };

  for (var line = 0; line < lines.length; line++) {
    var _ret = _loop(line);

    if (_ret === "break") break;
  }

  setImmediate(function () {
    return callback(null, res);
  });
};